import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLock = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.6237 6.33143H13.0329V4.79143C13.0329 2.1497 10.7456 0 7.93375 0C5.12235 0 2.8346 2.14931 2.8346 4.79143V6.33143H2.2438C1.55681 6.33143 1 6.85464 1 7.50017V14.8313C1 15.4768 1.55681 16 2.2438 16H13.6229C14.3099 16 14.8667 15.4768 14.8667 14.8313V7.50017C14.8667 6.85464 14.3099 6.33143 13.6229 6.33143H13.6237ZM5.60744 4.79104C5.60744 3.58568 6.65098 2.60511 7.93416 2.60511C9.21735 2.60511 10.2609 3.58568 10.2609 4.79104V6.33104H5.60785V4.79104H5.60744Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgLock)
const IconSvgLock = createIcon(ForwardRef, 'SvgLock')
export default IconSvgLock
